import { VideoSettingsState } from './types';

export const videoSettingsInitialState: VideoSettingsState = {
  form: {
    customTime: false,
    time: 0,
  },
  cta: {
    addCtaBtn: false,
    time: 0,
    text: '',
    size: 'M',
    textColor: 'rgb(255, 255, 255)',
    bgColor: 'rgb(255, 0, 0)',
    addLink: false,
    link: '',
    interactionMode: 'overlay',
    mergedPlacement: 'center',
    placement: 'center',
    pauseOnClick: true,
    // addBorder: false,
    // border: {
    //   width: 1,
    //   type: 'solid',
    //   color: '#000',
    // },
  },
  player: {
    autoplay: true,
    blockForwardSeek: true,
    blockBackwardSeek: true,
    hideIfEnded: false,
    allowPause: true,
    playPauseAnimation: true,
    tapToFullscreen: false,
    fontFamily: 'Arial',
    // doubleTapToFullscreen: false,
    // doubleTapToExitFullscreen: false,
    // escToExitFullscreen: true,
  },
  preview: {
    addPreview: true,
    placement: 'center',
    icon: 'soundOff',
    playFromStartAfterClose: false,
    size: 'M',
    textColor: 'rgb(255, 255, 255)',
    bgColor: 'rgba(0, 0, 0, 0.65)',
    text: '',
  },
  controls: {
    controlsVisibility: 'onHover',
    // background: true,
    // hidePlayButton: false,
    // hideFullscreenButton: false,
    // hideVolumeControl: false,
    // volumeToggleOnly: false,
    hideProgressBar: false,
    // showExternalProgressBar: false,
    // externalProgressBarHeight: 1,
    // externalProgressBarColor: 'rgb(0, 0, 0)',
  },
  playback: {
    addPlayback: false,
    showWhenPaused: true,
    showWhenNotFullscreen: false,
    size: 'M',
    text: '',
    textColor: 'rgb(255, 255, 255)',
    bgColor: 'rgba(0, 0, 0, 0.8)',
    placement: 'center',
  },
};
